module.exports = __webpack_public_path__ + "static/media/destination.81ee4325.png";